<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-also-by element-with-heading" id="also-by-pat-young">
<div class="heading heading-with-title heading-without-image" id="also-by-pat-young-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also By Pat Young</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-pat-young-text">
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Till The Dust Settles</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">I Know Where You Live</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobypatyoung.vue?634cf9b8